<div class="bmc-bot-processes" *ngIf="botProcesses && botProcesses.length">
    <h4 class="bz-font-weight--semibold bz-space--stack-m">{{ title | translate }}</h4>
    <ul class="bmc-bot-processes__items">
        <li *ngFor="let process of botProcesses; let i=index"
            class="bmc-bot-processes__item bz-space--inset-m bz-space--stack-s bz-shadow--xs bz-border-radius--m"
            [ngClass]="{'bz-space--inline-m': i % 2 === 0}">
            <h5 class="bmc-bot-processes__item__text bz-font-weight--semibold">{{process.displayName}}</h5>
        </li>
    </ul>
</div>